import { useState } from "react";
import {authService} from "../../../services"

const ChangeEmail = () => {
  const [email, setEmail] = useState("");
  const [oldEmail, setOldEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [requesting, setRequesting] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [message, setMessage] = useState("");

 const requestOtp = async () => {
     try {
       setRequesting(true);
       const { email } = await userService.myProfile();
       setOldEmail(email);
       const otp = await authService.generateOtp({ otpType: "email", email:oldEmail });
       if (otp) {
         setOtpSent(true);
         setRequesting(false);
         setMessage("OTP sent to your email.");
       } else {
         setMessage("Failed to send OTP.");
         setRequesting(false);
       }
     } catch {
       setRequesting(false);
       setMessage("Error sending OTP.");
     }
   };

  // Submit Email Change
  const handleEmailChange = async (e) => {
    e.preventDefault();

    try {
     const updateEmail=authService.updateEmail({newEmail:email, email:oldEmail, otpCode:otp})
     if (updateEmail) {
        setRequesting(false)
        setMessage("Email successfully updated!");
        setEmail("");
        setOtp("");
      } else {
        setMessage("Invalid OTP or error updating email.");
      }
    } catch {
      setMessage("Error updating email.");
    }
  };

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium">Change Email</h3>

      {!otpSent ? (
        <button onClick={requestOtp} className="bg-gray-800 text-white py-2 px-4 rounded hover:bg-gray-900" disabled={requesting}>
          {requesting?"Requesting...":"Request OTP"}
        </button>
      ) : (
        <form onSubmit={handleEmailChange} className="space-y-3">
          <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} className="w-full p-2 border rounded" required />
          <input type="email" placeholder="New Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full p-2 border rounded" required />
          <button type="submit" className="bg-gray-800 text-white py-2 px-4 rounded hover:bg-gray-900">
            Update Email
          </button>
        </form>
      )}

      {message && <p className="text-sm text-red-500 mt-2">{message}</p>}
    </div>
  );
};

export default ChangeEmail;
